import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class ThreatStack extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M21.319,2.267A1.681,1.681,0,1,0,23,3.948a1.7,1.7,0,0,0-1.681-1.681M12,2.191a1.757,1.757,0,1,0,1.757,1.757A1.777,1.777,0,0,0,12,2.191m0,4.736a1.681,1.681,0,1,0,1.681,1.681A1.7,1.7,0,0,0,12,6.927m0,4.736a1.6,1.6,0,1,0,1.6,1.6,1.614,1.614,0,0,0-1.6-1.6m0,9.511a1.413,1.413,0,1,0,1.413,1.413A1.41,1.41,0,0,0,12,21.174M2.681,2.267a1.681,1.681,0,1,0,0,3.361,1.7,1.7,0,0,0,1.68-1.68,1.671,1.671,0,0,0-1.68-1.681M12,16.4a1.492,1.492,0,0,0-1.49,1.49A1.517,1.517,0,0,0,12,19.378,1.49,1.49,0,1,0,12,16.4" />
        <path d="M21.319,7.194a1.452,1.452,0,1,0,1.452,1.452,1.5,1.5,0,0,0-1.452-1.452m0,4.851a1.261,1.261,0,0,0,0,2.521,1.261,1.261,0,0,0,0-2.521m0,4.813a1.07,1.07,0,1,0,1.07,1.069,1.12,1.12,0,0,0-1.07-1.069M16.66,4.712A1.528,1.528,0,1,0,18.187,6.24,1.557,1.557,0,0,0,16.66,4.712m0,4.736A1.452,1.452,0,1,0,18.111,10.9,1.5,1.5,0,0,0,16.66,9.448m0,4.851a1.26,1.26,0,1,0,1.26,1.26,1.272,1.272,0,0,0-1.26-1.26m0,4.812a1.07,1.07,0,1,0,1.069,1.07,1.093,1.093,0,0,0-1.069-1.07M7.34,4.712A1.528,1.528,0,1,0,8.868,6.24,1.532,1.532,0,0,0,7.34,4.712m0,4.736A1.452,1.452,0,1,0,8.792,10.9,1.45,1.45,0,0,0,7.34,9.448m0,4.851a1.26,1.26,0,0,0,0,2.52,1.239,1.239,0,0,0,1.223-1.26A1.216,1.216,0,0,0,7.34,14.3m0,4.812a1.07,1.07,0,1,0,1.07,1.07,1.094,1.094,0,0,0-1.07-1.07M2.681,7.194A1.452,1.452,0,1,0,4.132,8.646,1.451,1.451,0,0,0,2.681,7.194m0,4.851a1.261,1.261,0,1,0,0,2.521A1.239,1.239,0,0,0,3.9,13.306a1.194,1.194,0,0,0-1.222-1.261m0,4.813A1.07,1.07,0,1,0,3.75,17.927a1.068,1.068,0,0,0-1.069-1.069" />
      </svg>
    );
  }
}

export default ThreatStack;
